import React from 'react';
import {
    Button, AnchorButton,
    Tab, Tabs,
    ButtonGroup,
    Icon,
    EditableText,
    Toaster, Alert, Overlay, Popover, Tooltip, Card,
    Intent, Position, Classes, Elevation, Dialog, InputGroup, FormGroup
} from "@blueprintjs/core";
import NdbkAPI from '../ndbk-api';
import { Link } from 'react-router-dom'

export default class SignUpForm extends React.Component {
    state = {
        showPassword: false,
        emailInput: "",
        usernameInput: "",
        passwordInput: "",
        showError: false,
        errorMsg: ""
    }

    loginHandler = () => {
        NdbkAPI.auth.login({
            username: this.state.usernameInput,
            password: this.state.passwordInput
        }, ()=>{
            this.props.auth.checkAuth(()=>{
                this.props.history.push('/')
            })
        }, ()=>{
            console.log("Login after registration went wrong.")
            this.props.history.push('/landing')
        })
    }

    registerHandler = () => {
        this.setState({
            showError: false,
            errorMsg: ""
        }, ()=>{
            NdbkAPI.auth.register({
                username: this.state.usernameInput,
                email: this.state.emailInput,
                password: this.state.passwordInput
            }, () => {
                this.loginHandler()
            }, response => {
                this.setState({
                    showError: true,
                    errorMsg: response.err
                })
            })
        })
    }

    toggleShowPassword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        })
    }

    onUsernameChange = (e) => {
        this.setState({
            usernameInput: e.target.value,
            showError: false,
            errorMsg: ""
        })
    }

    onEmailChange = (e) => {
        this.setState({
            emailInput: e.target.value,
            showError: false,
            errorMsg: ""
        })
    }

    onPasswordChange = (e) => {
        this.setState({
            passwordInput: e.target.value
        })
    }

    onKeyUp = (e) => {
        if (e.key === "Enter") {
            this.registerHandler()
        }
    }

    render() {
        const lockButton = (
            <Tooltip content={`${this.state.showPassword ? "Hide" : "Show"} Password`} position="right">
                <Button
                    icon={this.state.showPassword ? "eye-open" : "eye-off"}
                    intent={Intent.WARNING}
                    minimal
                    onClick={this.toggleShowPassword}
                />
            </Tooltip>
        );

        return (
            <div className="landing-registration" onKeyUp={e=>{
                if (e.key==="Enter") {
                    this.registerHandler()
                }
            }}>
                <div className="auth">
                    <AnchorButton
                        href="https://nodebook.io/api/auth/google"
                        text="Sign in with Google"
                        intent="danger"
                        className="auth-button"
                    />
                    <AnchorButton
                        href="https://nodebook.io/api/auth/twitter"
                        text="Sign in with Twitter"
                        intent="primary"
                        className="auth-button"
                    />
                </div>
                <div className="new">
                    <hr/>
                    <InputGroup
                        id="email"
                        large
                        placeholder="Email"
                        leftIcon="envelope"
                        autoComplete="false"
                        type="email"
                        value={this.state.emailInput}
                        onChange={this.onEmailChange}
                        autoFocus={true}
                    />
                    <InputGroup
                        id="username"
                        large
                        placeholder="Username"
                        leftIcon="person"
                        autoComplete="false"
                        value={this.state.usernameInput}
                        onChange={this.onUsernameChange}
                        spellCheck={false}
                    />
                    <InputGroup
                        id="password"
                        large
                        placeholder="Password"
                        leftIcon="lock"
                        rightElement={lockButton}
                        type={this.state.showPassword ? "text" : "password"}
                        value={this.state.passwordInput}
                        onChange={this.onPasswordChange}
                        spellCheck={false}
                    />
                    <div style={{float: "right"}}>
                        <Tooltip content={this.state.errorMsg} position="right" intent="danger" isOpen={this.state.showError}>
                            <Button
                                text="Sign up"
                                rightIcon="arrow-right"
                                intent="success"
                                style={{marginLeft: "10px"}}
                                onClick={this.registerHandler}
                            />
                        </Tooltip>
                    </div>

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/SignUpForm.js